import React from 'react';

import * as ReactDOMClient from 'react-dom/client';
import { App } from 'App';
import 'regenerator-runtime/runtime';
import 'core-js/stable';

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);
root.render(<App />);
